/** A trip's elapsed length in words, compact: "45 min", "4 h 30 min", "2 d 8 h" — the
 *  bookings list's `duration_s` (end − start). From a day on, minutes are dropped (rounded
 *  to the hour) because they are noise at that scale. "—" when unknown or negative. */
export function formatTripDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || !Number.isFinite(seconds) || seconds < 0) {
    return '—';
  }
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 24 * 60) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m ? `${h} h ${m} min` : `${h} h`;
  }
  const hours = Math.round(minutes / 60);
  const d = Math.floor(hours / 24);
  const h = hours % 24;
  return h ? `${d} d ${h} h` : `${d} d`;
}
